import { Howl } from 'howler';

export enum BreathType {
	INHALE = 'inhale',
	EXHALE = 'exhale',
	HOLD = 'hold',
	INHALE_CHEST = 'inhale_chest',
	INHALE_BELLY = 'inhale_belly',
}

export type BreathAction = {
	duration: number;
	type: string;
	audio: Howl;
	instruction: string;
};
